<template>
  <div>
    <b-card v-if="showOption">
      <div class="text-black mb-2 text-2xl font-semibold">
        Riwayat & Label
      </div>
      <b-row>
        <b-col md="4">
          <b-card
            img-src="https://storage.googleapis.com/komerce/assets/illustration/pickup-komship.svg"
            style="border:1px solid #E2E2E2;border-radius:16px;"
            img-alt="Input Cepat"
            img-top
            body-class="text-center"
          >
            <b-card-title class="text-black text-2xl !mb-[8px] font-semibold">
              Pickup Order Komship
            </b-card-title>
            <b-card-text class="min-h-[50px]">
              Pickup untuk orderan dari Komship
            </b-card-text>
            <b-button
              variant="primary"
              @click="pickupKomship = true, showOption = false"
            >
              Pilih
            </b-button>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card
            img-src="https://storage.googleapis.com/komerce/assets/illustration/packing-nonkomship.svg"
            style="border:1px solid #E2E2E2;border-radius:16px"
            img-alt="Mutasi Rekening"
            img-top
            body-class="text-center"
          >
            <b-card-title class="text-black text-2xl !mb-[8px] font-semibold">
              Packing Order Non-Komship
            </b-card-title>
            <b-card-text class="min-h-[50px]">
              Request packing untuk orderan yang tidak kamu buat melalui Komship
            </b-card-text>
            <b-button
              variant="primary"
              @click="handleSelectPacking"
            >
              Pilih
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <div v-if="pickupKomship">
      <HistoryPickup
        :user-data="userData"
        :back-button="backButton"
        @back="showOption = true, pickupKomship = false"
      />
    </div>
    <div v-if="isNonKomship">
      <HistoryPacking
        :user-data="userData"
        :back-button="backButton"
        @back="handleBackFromPacking"
      />
    </div>
  </div>
</template>

<script>
import secureLs from '@/libs/secureLs'
import HistoryPickup from '../komship/pickup/HistoryPickup/HistoryPickup.vue'
import HistoryPacking from '../kompack/packing/HistoryPacking.vue'

export default {
  components: {
    HistoryPickup,
    HistoryPacking,
  },
  data() {
    return {
      userData: secureLs.getItem('userData'),
      pickupKomship: false,
      showOption: false,
    }
  },
  computed: {
    hasFullAccess() {
      return this.userData.is_komship === 1 && this.userData.is_kompack === 1
    },
    hasKomshipOnly() {
      return this.userData.is_komship === 1 && this.userData.is_kompack === 0
    },
    hasKompackOnly() {
      return this.userData.is_komship === 0 && this.userData.is_kompack === 1
    },
    isNonKomship() {
      return this.$route.query.type === 'non-komship'
    },
    backButton() {
      return this.hasFullAccess
    },
  },
  watch: {
    isNonKomship: {
      handler(val) {
        if (this.hasFullAccess) {
          this.showOption = !val
        }
      },
    },
  },
  created() {
    if (this.hasFullAccess) {
      this.showOption = !this.isNonKomship
    } else if (this.hasKomshipOnly) {
      this.pickupKomship = true
    } else if (this.hasKompackOnly && !this.isNonKomship) {
      this.$router.replace({ query: { type: 'non-komship' } })
    }
  },
  methods: {
    updateQuery(query) {
      this.$router.push({ path: this.$route.path, query }).catch(() => {})
    },
    handleSelectPacking() {
      this.showOption = false
      this.updateQuery({ type: 'non-komship' })
    },
    handleBackFromPacking() {
      if (this.hasFullAccess) {
        this.updateQuery({})
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
img { position: relative; z-index: 100; }
</style>
